<template>
  <div>
    <v-app-bar app clipped-left clipped-right color="primary" dark>
      <v-toolbar-title class="align-center d-flex">
        <!-- <span class="logo-icon"> -->
        <img src="../../assets/s2s_logo.png" class="mr-3" height="40" />
        <!-- {{ dashboardRole.name }} -->
        <!-- {{ userData.adminLogin ? userData.adminLogin.name : "" }}  -->
        <!-- </span> -->
        <!-- <span class="logo-text ml-2"> -->
        <!-- <img src="../../assets/logo-light-text.png" class="mt-2" /> -->
        <!-- Dashboard -->
        <!-- </span> -->
      </v-toolbar-title>
      <v-app-bar-nav-icon
        @click="
          $vuetify.breakpoint.smAndDown
            ? setSidebarDrawer(!Sidebar_drawer)
            : $emit('input', !value)
        "
      />
      <v-spacer />
      <!-- <v-tooltip v-if="$vuetify.theme.dark" bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="white" icon small @click="darkMode">
            <v-icon class="mr-1">mdi-moon-waxing-crescent</v-icon>
          </v-btn>
        </template>
        <span>Dark Mode On</span>
      </v-tooltip> -->

      <!-- <v-tooltip v-else bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="info" icon small @click="darkMode">
            <v-icon color="yellow">mdi-white-balance-sunny</v-icon>
          </v-btn>
        </template>
        <span>Dark Mode Off</span>
      </v-tooltip> -->

      <!-- <v-btn dark text @click="logout">
      Logout
      <v-icon>mdi-logout-variant</v-icon>
    </v-btn>

     -->

      <!-- <template v-if="userData.adminLogin"> -->
      <v-btn text @click="showDashboardList" v-if="roles.length > 1">
        <v-icon class="mr-1">mdi-monitor-dashboard</v-icon>
        Dashboard
      </v-btn>
      <!-- </template> -->

      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text>
            <v-icon>mdi-account</v-icon>
            {{ userData.name ? userData.name : "User" }}
          </v-btn>
        </template>

        <v-list>
          <!-- <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="handleClick(index)"
        > -->
          <v-list-item @click="showChangePasswordDialog()">
            <v-list-item-icon>
              <v-icon>mdi-lock-reset</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Change Password</v-list-item-title>
          </v-list-item>

          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <ChangePasswordDialog
      :dialog="changePasswordDialog.dialog"
      @close="changePasswordDialog.dialog = !changePasswordDialog.dialog"
    ></ChangePasswordDialog>

    <DashboardListDialog
      :dialog="dashboardListDialog.dialog"
      @close="dashboardListDialog.dialog = !dashboardListDialog.dialog"
    ></DashboardListDialog>
  </div>
</template>
<script>
// Utilities
// import { mapState } from "vuex";
import ChangePasswordDialog from "../../views/dialogs/ChangePasswordDialog.vue";
import DashboardListDialog from "../../views/dialogs/DashboardListDialog.vue";

export default {
  name: "Header",

  components: {
    ChangePasswordDialog,
    DashboardListDialog,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      userprofile: [
        { title: "My Profile" },
        // { title: "My Balance" },
        // { title: "Inbox" },
        // { title: "Account Setting" },
        { title: "Logout" },
      ],
      href() {
        return undefined;
      },

      items: ["asdasd", "Adasdasd", "Asdasdasdas dasd sd a"],

      // items: [
      //   {
      //     title: "Edit",
      //     icon: "mdi-pencil",
      //     click() {
      //       console.log("edit");
      //     },
      //   },
      //   {
      //     title: "Due Date",
      //     icon: "mdi-calendar",
      //     click() {
      //       console.log("due date");
      //     },
      //   },
      //   {
      //     title: "Delete",
      //     icon: "mdi-delete",
      //     click() {
      //       this.$store.dispatch("deleteTask", 1);
      //     },
      //   },
      // ],

      changePasswordDialog: {
        dialog: false,
      },

      dashboardListDialog: {
        dialog: false,
      },
    };
  },

  created() {
    console.log(this.$vuetify.theme.dark);
  },

  computed: {
    // ...mapState({
    //   Sidebar_drawer: (state) => state.SidebarDrawerModule.Sidebar_drawer,
    // }),

    Sidebar_drawer() {
      return this.$store.getters.getSidebar.Sidebar_drawer;
    },

    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },

    userData() {
      return this.$store.getters.userData;
    },

    dashboardRole() {
      return this.$store.getters.dashboardRole;
    },

    roles() {
      const current = this.$store.getters.userData;

      if (Object.keys(current).length === 0) {
        return [];
      }

      const roles = current.adminLogin.roles.filter((role) => {
        return role.code != "api";
      });
      return roles;
    },
  },

  methods: {
    // ...mapMutations({
    //   setSidebarDrawer: "SET_SIDEBAR_DRAWER",
    // }),

    setSidebarDrawer(e) {
      this.$store.dispatch("ADD_SIDEBAR_DRAWER", e);
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$store.dispatch("addDashboardRole", {});
        this.$router.push("/");
      });
    },

    // handleClick() {

    // },

    showChangePasswordDialog() {
      this.changePasswordDialog.dialog = true;
    },

    showDashboardList() {
      this.dashboardListDialog.dialog = true;
    },

    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
};
</script>
